import React from 'react';
import './dotLoader.css';

const DotLoader = () => {
  return <div className="dotPulse" />;
};

export default DotLoader;
